import { useState } from 'react'

const SIZE_CLASSES = {
  xs: 'w-5 h-5 text-[10px]',
  sm: 'w-6 h-6 text-xs',
  md: 'w-7 h-7 text-xs',
  lg: 'w-8 h-8 text-sm',
  xl: 'w-9 h-9 text-base',
  '2xl': 'w-14 h-14 text-2xl',
  '3xl': 'w-24 h-24 text-4xl',
  // For the single biggest face on a page. The Royalty global crown needs
  // to outrank the category crowns beside it, and those are 3xl.
  '4xl': 'w-32 h-32 text-5xl',
}

export default function Avatar({ user, size = 'md', className = '' }) {
  const [imgError, setImgError] = useState(false)
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md
  const name = user?.display_name || user?.username || ''
  const fallback = user?.avatar_emoji || name[0]?.toUpperCase() || '?'

  if (user?.avatar_url && !imgError) {
    return (
      <img
        src={user.avatar_url}
        alt=""
        className={`rounded-full object-cover flex-shrink-0 ${sizeClass} ${className}`}
        onError={() => setImgError(true)}
      />
    )
  }

  return (
    <span className={`rounded-full flex items-center justify-center flex-shrink-0 ${sizeClass} ${className || 'bg-bg-primary'}`}>
      {fallback}
    </span>
  )
}
